export default "__VITE_ASSET__d585d88d__"